import React, { useEffect, useRef, useState } from "react";
import CheckoutForm from "./Checkoutform";
import styled from "styled-components";
import Modal from "react-modal";

import { Bars } from "react-loader-spinner";

import {sendIndiaBidToBackend} from '../../utils/backendUtils';
import {initializeRazorpay} from '../../utils/paymentHelpers';

import eventBus from '../../utils/globalPubSub';

import SuccessBidComponent from './SuccessBidComponent'

import CancelIcon from "../../assets/cancel_icon.svg";


const HeaderSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 130.5%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
`

const InputContainerDiv = styled.div`
  width: 100%;
  height: 44px;
  display:flex;
  border: 1px solid rgba(255, 255, 255, 0.08);
  align-items: center;
`

const StyledInput = styled.input`
  width: 398px;
  height: 19px;
  background: #131313;
  padding: 11px 16px;
  display: flex;
  align-items: center;
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  border: none;
  color: white;
  :placeholder,
  :-webkit-input-placeholder {
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: rgba(255, 255, 255, .4);
  }
`

const DollarSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: right;
  color: #FFFFFF;
  opacity: 0.45;
`

const CurrentTopBidDiv = styled.div`
  display: flex;
  margin-top: 16px;
`

const InformationSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.45); 
`

const ButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;   
`

const PlaceBidButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 44px;
  background: #FFFFFF;
  margin-top: 16px;
  cursor: pointer;
  border-radius: 12px;
`

const GlipHelpTextSpan = styled.span`  
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 140%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
  opacity: 0.7;
  display: block;
`

const ErrorSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #FF5A5A;
`

const TopUpInformationDiv = styled.div`
  width: 100%;
  height: 68px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 12px;
`

const TopUpInformationSpan = styled.span`
  font-family: 'IBM Plex Mono';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
`

function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
}

export default function Web2IndiaBidComponent(props) {
    
    const [inputText, setInputText] = useState('');
    const [error, setError] = useState('');
    const [loader, setLoader] = useState(false);
    const [success, setSuccess] = useState(false);
    const [currCut, setCurrCut] = useState(0);
    
    useEffect(()=>{
        setInputText('');
        setError('');
        setSuccess(false);
        setLoader(false);
    }, [props.isOpen]);
    
    const handleInputText = (value) => {
        let adjustedValue = (value.indexOf(".") >= 0) ? (value.substr(0, value.indexOf(".")) + value.substr(value.indexOf("."), 3)) : value;
        if(adjustedValue - props.topBidUser >0 ){
            setCurrCut(adjustedValue - props.topBidUser)
        }
        setInputText(adjustedValue);
    }
    
    const sendBid = async (val) => {
        setLoader(true);
        let resp = await sendIndiaBidToBackend(
            val, props.item.auctionId, props.item._id);
        setLoader(false);
        if(!resp){
            setError('Failed');
            setTimeout(()=>{setError('')}, 5000);
            return
        }
        if(!resp.success){
            setError(resp.message);
            setTimeout(()=>{setError('')}, 5000);
            return;
        }
        if(resp.success){
            //
            initializeRazorpay(
                val, resp.data.order.id,
                (err)=>{
                    setError(err);
                    setTimeout(()=>{setError('')}, 5000);
                },
                () => {
                    setSuccess(true);
                    eventBus.dispatch("new-bid-add");
            });
        }
    }

    const handleModalCloseEvent = ()=>{
        props.closeModal()
    }

    const [width, setWidth] = useState<number>(window.innerWidth);
    
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const isMobile = width <= 768;

    let modalWidth = "351px";
    let modalHeight = "410px";
    if(!isMobile){
        modalWidth = "447px";
        modalHeight = "410px";
    }
    if(props.topBidUser == 0){
        modalHeight = "310px";
    }
    return (
	<Modal
	    isOpen={props.isOpen}
	    style={{
	        content: {
		    background: "#0F0F0F",
		    width: modalWidth,
		    height: modalHeight,
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)',
		    border:"none",
	    }}}
	>
            <div style={{marginLeft:24, marginTop:30,
		         marginRight:24, marginBottom:30,
		         position: "relative"}}>
                <img onClick={()=>{handleModalCloseEvent()}}
	             src={CancelIcon}
	             style={{
	                 position: "absolute", opacity: 0.4,
	                 height: 14, width:14,
	                 right:10, cursor:"pointer",
	                 zIndex:10
	             }}
	        />
                {!success && (
                    <>
	                <HeaderSpan>BID {(props.topBidUser != 0) && (<>MORE</>)}</HeaderSpan>
	                <InputContainerDiv style={{marginTop: 24}}>
                            <span style={{marginLeft:10}}>&#8377;
                            </span>
		            <StyledInput
		                placeholder={"Enter amount"}
		                value={inputText}
		                type="number"
		                onChange={e =>handleInputText(e.target.value)}
		            />
	                </InputContainerDiv>
                        {error && (
		            <ErrorSpan style={{marginTop: 16}}>{error}
		            </ErrorSpan>
	                )}
                        {/*
	                    <CurrentTopBidDiv>
		            <InformationSpan>
		            Current top bid: 83 MATIC / $20
		            </InformationSpan>
	                    </CurrentTopBidDiv>
                          */}
                        <div style={{
                            display:'flex',
                            justifyContent: 'flex-start',
                            marginTop: 18
                        }}>
                            {(props.topBidUser != 0) && (
                                <div style={{display:'flex'}}>
                                    <InformationSpan>Your bid:&nbsp;</InformationSpan>
                                    <InformationSpan style={{color:'white'}}> {props.topBidUser} Rs</InformationSpan>
                                </div>
                            )}
                            {(props.topBidUser != 0) && (
                                <div style={{display:'flex', marginLeft:18}}>
                                    <InformationSpan>Top bid:&nbsp;</InformationSpan>
                                    <InformationSpan style={{color:'white'}}>{props.topBid} Rs</InformationSpan>
                                </div>
                            )}
                            
                        </div>
                        <>
                            {(props.topBidUser != 0) && (
                                <TopUpInformationDiv>
                                    {inputText && (
                                        <TopUpInformationSpan>
                                            YOU ONLY NEED TO DEPOSIT {currCut} Rs<br/>
                                        </TopUpInformationSpan>
                                    )}
                                    {!inputText && (
                                        <TopUpInformationSpan>
                                            BID MONEY ON TOP<br/> OF YOUR {props.topBidUser} Rs BID
                                        </TopUpInformationSpan>
                                    )}
                                </TopUpInformationDiv>
                            )}
	                    <PlaceBidButtonDiv onClick={()=>{
                                if(loader){
                                    return;
                                }
                                sendBid(currCut)}}>
                                {(!loader) && (
                                    <ButtonTextSpan>
	                                PLACE BID
	                            </ButtonTextSpan>
                                )}
                                {(loader) && (
                                    <Bars
                                        heigth="30" width="30"
                                        color="grey"
                                        ariaLabel="loading-indicator" />
                                )}	                    
	                    </PlaceBidButtonDiv>
                        </>
                    </>
                )}
                {success && (
                    <SuccessBidComponent
                        handleModalCloseEvent={handleModalCloseEvent}>
                    </SuccessBidComponent>
                )}
            </div>
        </Modal>
        
    );
}
